import { navigate } from "gatsby"
import { Coupon } from "../components/molecules/Coupons/Coupons.d"

export class CouponsClient {
  public static url: string = `${process.env.GATSBY_API_URL}/coupon`
  private static key: string = process.env.GATSBY_API_KEY

  /**
   * Makes an arbitrary call to the Coupons API
   *
   * @param {string} endpoint - The endpoint to call beyond the base URL
   * @param {"GET"|"POST"|"DELETE"|"UPDATE"} method - Which HTTP method to use
   * @param {any} params - Key/value object that will be converted to URL query params in the call
   *
   * @returns {Promise<T>} - JSON response from the API
   */
  private static fetch = async <T>(
    endpoint: string,
    method: "GET",
    params?: any,
  ): Promise<T> => {
    const url = `${this.url}${endpoint}${
      params && "?" + new URLSearchParams(params)
    }`

    const config = {
      method: method,
      headers: {
        "x-api-key": this.key,
        Accept: "application/vnd.apple.pkpass",
      },
    }

    try {
      const res = await fetch(url, config)
      if (params?.deviceType === "android") {
        // Google Wallet
        const json = await res.json()
        const googleWalletLink = json?.googleWalletLink
        if (googleWalletLink) {
          navigate(googleWalletLink)
          return
        }
      } else {
        // Apple Wallet
        //download the file
        const file = await res.blob()
        const fileUrl = URL.createObjectURL(file)
        const a = document.createElement("a")
        a.href = fileUrl
        a.download = "coupon.pkpass"
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        return
      }
    } catch (error) {
      console.error(`Couldn't fetch coupon.`, error)
    }
  }

  /**
   * Gets data for a single coupon by its id
   *
   * @param couponId - The coupon id to return info for
   *
   * @returns {Coupon} - A single coupon object
   */
  public static getCoupon = (couponId: string, deviceType: string) => {
    return this.fetch<Coupon>("", "GET", {
      id: couponId,
      deviceType: deviceType,
    })
  }
}
